export const SET_SUCCESS = "SET_SUCCESS";

export const setSuccess = success => ({
  type: SET_SUCCESS,
  success: success
});
